import React from 'react'
import Table from './table'
export default function List() {
  return <Table />
}
